import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

// One bulkPurchaseCreateAction call is made per (vendor, ship-to address)
// document — this modal just reflects that loop's progress back to the user
// while it runs; it has no controls of its own (onClose is a no-op) since
// the create loop can't be cancelled mid-flight.
const BulkPoCreatingModal = ({ isOpen, current, total }) => {
  const safeTotal = Math.max(total, 0);
  const safeCurrent = Math.min(Math.max(current, 0), safeTotal);
  const progressPct = safeTotal > 0 ? (safeCurrent / safeTotal) * 100 : 0;

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-[60] overflow-y-auto" onClose={() => {}}>
        <div className="flex items-center justify-center min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="mx-auto w-full max-w-sm my-8 p-6 text-left align-middle bg-[var(--create-table-row-bg)] shadow-xl rounded-md">
              <h2 className="text-base font-semibold text-[var(--heading-color)]">
                Creating Purchase Orders
              </h2>
              <p className="mt-1 text-sm text-[var(--description-color)]">
                Adding {safeCurrent} out of {safeTotal}
              </p>
              <div className="mt-4 h-2 rounded-full bg-[var(--gray-200)] overflow-hidden">
                <div
                  className="h-full bg-[var(--primary)] transition-all"
                  style={{ width: `${progressPct}%` }}
                />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default BulkPoCreatingModal;
